// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3HRnP","row":"ProcedureTreatmentSummary_row__1bB72"};